import { SplitFactory } from '@splitsoftware/splitio';

let clientInstance: any;

export function useSplit() {
  if (!clientInstance && process.env.VUE_APP_SPLIT_SDK_KEY) {
    const factory = SplitFactory({
      core: {
        authorizationKey: process.env.VUE_APP_SPLIT_SDK_KEY, 
        key: 'all',
      },
    });

    clientInstance = factory.client();
  }

  return {
    client: clientInstance,
  };
}
